import { render, staticRenderFns } from "./prospectsModal.vue?vue&type=template&id=66adc8e4&"
import script from "./prospectsModal.vue?vue&type=script&lang=js&"
export * from "./prospectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports